<template>
  <div class="otto-client-search">
    <input
      type="text"
      class="otto-input otto-input--search"
      v-model="client"
      @input="onChange"
      @keyup.down="onArrowDown"
      @keyup.up="onArrowUp"
      @keyup.enter="onEnter"
      @keyup.delete="onDelete"
    />

    <SearchIcon class="otto-client-search-icon" />
    <div v-show="this.inputValue !== ''" class="otto-client-search-clear-wrapper"  @click="clearSearch">
      <Close class="otto-client-search-clear-icon" />
    </div>
    <div
      v-show="isOpen"
      class="autocomplete-results"
    >
      <div
        class="loading"
        v-if="isLoading">
        Loading clients...
      </div>
      <div
        v-else
        v-for="(client, i) in clients"
        :key="i"
        @click="setResult(client)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        <p class="autocomplete-result__name">{{ client.first_name }} {{client.last_name}}</p>
        <p class="autocomplete-result__info">{{ formatPhoneNumber(client.phone_number) }}</p>
        <p class="autocomplete-result__info">{{ client.email}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Close from '@/components/Cancel.svg';
import { formatPhoneNumber, stripPhoneNumber } from '@/utils';
import SearchIcon from './search-icon.svg';


export default {
  name: 'client-search',
  components: {
    SearchIcon,
    Close,
  },
  data() {
    return {
      resultRowHeight: 70,
      isOpen: false,
      currentClient: null,
      isLoading: false,
      arrowCounter: -1,
      inputValue: '',
    };
  },
  computed: {
    ...mapState({
      clients: state => state.booking.currentSearchedClients,
    }),
    client: {
      get() {
        if (this.currentClient) {
          return `${this.currentClient.first_name} ${this.currentClient.last_name}`;
        }

        return this.inputValue;
      },
      set(value) {
        this.inputValue = value;
      },
    },
  },
  methods: {
    ...mapActions([
      'getClients',
      'setClient',
    ]),
    onChange() {
      this.isLoading = true;
      this.isOpen = true;
      this.currentClient = null;
      if (this.inputValue === '') {
        this.setClient({});
        this.isOpen = false;
      }
      this.getClients(this.inputValue)
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          console.log('error fetching clients', err);
        });
    },
    clearSearch() {
      this.inputValue = '';
      this.currentClient = null;
      this.isOpen = false;
      this.setClient({});
    },
    onDelete() {
      this.currentClient = null;
    },
    setResult(result) {
      this.currentClient = result;
      this.setClient(result);
      this.isOpen = false;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    formatPhoneNumber(number) {
      return formatPhoneNumber(stripPhoneNumber(number));
    },
    onArrowDown() {
      if ((this.arrowCounter + 1) < this.clients.length) {
        this.arrowCounter = this.arrowCounter + 1;
        const scrollPos = (this.arrowCounter + 1) * this.resultRowHeight;

        if (scrollPos > this.$results.offsetHeight) {
          this.$results.scrollTop = scrollPos - this.$results.offsetHeight;
        }
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        const scrollPos = (this.arrowCounter + 1) * this.resultRowHeight;
        const currentOffset = this.$results.offsetHeight + this.$results.scrollTop;
        if (scrollPos < currentOffset) {
          this.$results.scrollTop = scrollPos - this.resultRowHeight;
        }
      }
    },
    onEnter() {
      this.setResult(this.clients[this.arrowCounter]);
      this.arrowCounter = -1;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.$results = this.$el.querySelector('.autocomplete-results');
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>


<style>
  .otto-client-search {
    position: relative;
    width: 100%;
  }

  .otto-input--search {
    border-radius: 3px;
    height: 36px;
    border: 1px solid rgb(225, 225, 225);
    padding-left: 34px;
  }

  .otto-client-search-icon {
    position: absolute;
    top: 7px;
    left: 7px;
  }

  .otto-client-search-clear-wrapper {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
  }

  .otto-client-search-clear-icon {
    display: block;
    cursor: pointer;
    color: #9B9B9B;
  }

  .otto-client-search-clear-icon:hover {
    color: #843CAE;
  }

  .autocomplete-results {
    position: absolute;
    background: #fff;
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 210px;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 8px;
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #eeeeee;
  }

  .autocomplete-result:last-child {
    border-bottom: none;
  }

  .autocomplete-result__name {
    font-size: 15px;
    margin: 4px 0;
  }

  .autocomplete-result__info {
    font-size: 13px;
    margin: 2px 0;
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #843CAE;
    color: white;
  }
</style>




// WEBPACK FOOTER //
// src/components/ClientSearch.vue